import { render, staticRenderFns } from "./lgsecret.vue?vue&type=template&id=2bc82d8a&"
import script from "./lgsecret.vue?vue&type=script&lang=js&"
export * from "./lgsecret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports